import { Box } from '@mui/material'
import TextField from '@mui/material/TextField'
import { useState } from 'react'

const InputCustom = ({
	name, // name for input component, string
	type, // type of input, string
	enableShowPassword, // enable show password functionality, boolean
	placeholder, // string
	setDataFunction = () => {}, // a useState function that sets data, function
	data, // json object recommended to work properly
	autoFocus, //
	value, // value of the input
	min, // min value for number inputs, number
	max, // max value for number inputs, number
	required, // for required inputs, boolean
	disabled, // disable the input field, boolean
	data_cy, // for cypress tests
	className,
	searchIcon,
	eyeIcon,
	children,
	label,
    changeFunction = () => {},
	...props
}) => {
	const [showPassword, setShowPassword] = useState(false)

	// toggles between showing and hiding password
	const handlePassword = () => {
		setShowPassword((prev) => !prev)
	}

	// update useState data on change (json object)
	const handleChange = (e) => {
		const val = e.target.value
		const nextValue =
			type === 'number'
				? Number(val)
				: type === 'password'
					? val.trim()
					: val
		if (typeof setDataFunction === 'function') {
			const base =
				data && typeof data === 'object' && !Array.isArray(data)
					? data
					: {}
			setDataFunction({
				...base,
				[e.target.name]: nextValue,
			})
		}
		changeFunction()
	}
	return (
		<div
			style={{
				position: 'relative',
				width: '100%',
				height: '100%',
				// display: 'flex',
				// alignItems: 'center',
			}}
		>
			{label && (
				<label
					htmlFor={placeholder}
					className={`${className}`}
					style={{
						marginBottom: '5px',
						fontWeight: '500',
						fontSize: '14px',
						color: '#313131',
						display: 'block',
						...props.labelStyle
					}}
				>
					{label}
				</label>
			)}
			<TextField
				variant="outlined"
				min={min}
				max={max}
				value={value}
				name={name}
				required={required}
				placeholder={placeholder}
				id={placeholder}
				type={
					enableShowPassword
						? showPassword
							? 'text'
							: 'password'
						: type
				}
				onChange={handleChange}
				onWheel={(e) => {
					if (type === 'number') e.target.blur()
				}}
				autoFocus={autoFocus}
				disabled={disabled}
				data-cy={data_cy}
				className={className}
				{...props}
				sx={{
					width: '100%',
					'& .MuiInputBase-root': {
						borderRadius: '8px',
						minHeight: '40px',
						borderColor: '#E8EBEE',

						'& fieldset': {
							borderColor: '#E8EBEE',
						},
						'&:hover fieldset': {
							borderColor: '#E8EBEE', // Remove border on hover
						},
						'&.Mui-focused fieldset': {
							borderColor: '#7CA6BD', // Remove blue border when focused
						},
						'& .Mui-disabled': {
							backgroundColor: '#F2F6F8 !important',
							border: 'transparent  !important',
							'& .MuiOutlinedInput-notchedOutline': {
								borderColor: 'transparent  !important',
							},
						},
						'@media (max-width: 600px)': {
							minHeight: '35px',
						},
					},
					'& .MuiInputBase-input': {
						padding: searchIcon
							? '10px 12px 10px 36px'
							: eyeIcon
								? '10px 40px 10px 12px'
								: '10px 12px',
						color: '#000',
						borderRadius: '8px',
						fontSize: '14px',
						bgcolor: '#fff',
						'&::placeholder': {
							color: '#98A2B1 !important',
							opacity: ' 1 !important',
						},
						'@media (max-width: 600px)': {
							padding: searchIcon
								? '7px 12px 7px 30px'
								: eyeIcon
									? '7px 30px 7px 12px'
									: '7px 12px',
						},
					},
					'& .Mui-disabled': {
						backgroundColor: '#F2F6F8 !important',
						border: 'transparent  !important',
						'& .MuiOutlinedInput-notchedOutline': {
							borderColor: 'transparent !important',
						},
					},
				}}
			/>

			{searchIcon && (
				<Box
					sx={{
						position: 'absolute',
						top: '50%',
						left: '12px',
						transform: 'translateY(-50%)',
						width: { xs: '16px', sm: '18px' },
						height: { xs: '16px', sm: '18px' },
						pointerEvents: 'none',
					}}
				>
					<img
						src={
							typeof searchIcon === 'string'
								? searchIcon
								: '/images/search-icon.svg'
						}
						alt="search"
					/>
				</Box>
			)}

			{eyeIcon && (
				<Box
					sx={{
						position: 'absolute',
						top: '50%',
						right: '10px',
						transform: 'translateY(-50%)',
						cursor: 'pointer',
						width: { xs: '16px', sm: '18px' },
						height: { xs: '16px', sm: '18px' },
					}}
					onClick={handlePassword}
				>
					{enableShowPassword && (
						<img
							data-cy="showPassword"
							src={
								showPassword
									? '/images/eye-open-icon.svg'
									: '/images/eye-close-icon.svg'
							}
							alt="toggle password visibility"
						/>
					)}
				</Box>
			)}
		</div>
	)
}

export default InputCustom
